module.exports = __webpack_public_path__ + "static/media/IMG_3568_2.b371f901.jpg";